import React, { useState, useEffect } from "react";

function getValue(value: number, isInteger: boolean) {
  if (isInteger) {
    return Math.round(value).toFixed(2);
  } else {
    return value.toFixed(2);
  }
}

type Props = {
  name: string;
  label: string;
  value: number;
  unit?: string;
  min: number;
  max: number;
  onChange?: (value: number) => void;
  style?: React.CSSProperties;
  textBoxStyle?: React.CSSProperties;
  disabled?: boolean;
  isInteger: boolean;
  readOnly?: boolean;
};

export default function LabelTextBox({
  name,
  label,
  value,
  unit,
  min,
  max,
  onChange = () => {},
  style = {},
  textBoxStyle = {},
  disabled = false,
  isInteger,
  readOnly = false,
}: Props) {
  const [isError, setIsError] = useState(false);
  const [tbValue, setTbValue] = useState(getValue(value, isInteger));

  useEffect(() => {
    console.log("LABEL", getValue(value, isInteger));
    setTbValue(getValue(value, isInteger));
  }, [value, isInteger]);

  const onBlur = (e: React.FocusEvent<HTMLInputElement>): void => {
    let { value } = e.target;
    let numberValue = parseFloat(value);
    if (isNaN(numberValue)) {
      setIsError(true);
      return;
    }

    if (max && min) {
      if (numberValue > max || numberValue < min) {
        setIsError(true);
        return;
      }
    }

    setIsError(false);
    if (isInteger) {
      numberValue = Math.round(numberValue);
    }
    setTbValue(getValue(numberValue, isInteger));
    onChange(numberValue);
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "baseline",
        //justifyContent: "flex-start",
        backgroundColor: isError ? "red" : "transparent",
        color: disabled ? "#808080" : "#000000",
        ...style,
      }}
    >
      <label
        style={{
          width: 100,
          lineHeight: "16px",
          textAlign: "left",
          flexShrink: 0,
          flexGrow: 0,
        }}
      >
        {label}
      </label>
      <label style={{ width: 20, lineHeight: "34px", flexShrink: 0, flexGrow: 0 }}>:</label>
      <input
        type="number"
        style={{
          minWidth: "40px",
          flexShrink: 1,
          flexGrow: 0,
          flexBasis: "50px",
          height: "34Px",
          paddingLeft: "5px",
          color: disabled ? "#808080" : "#000000",
          marginRight: "10px",
          ...textBoxStyle,
        }}
        name={name}
        value={tbValue}
        onChange={readOnly ? () => {} : (e) => setTbValue(e.target.value)}
        onBlur={readOnly ? () => {} : onBlur}
        disabled={disabled}
        readOnly={readOnly}
      />
      {unit && (
        <span style={{ textAlign: "left", flex: 1 }}>{unit}</span>
      )}
    </div>
  );
}
